import { LEGAL_FORM_LEGAL_FORM_OF_OFFER_LEGAL } from './product-capture-field-selectors.consts';

import { FCSelector } from '../../model/form-config.interface';

export enum LegalSubscriptionType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export const LEGAL_SUBSCRIPTION_TYPE: FCSelector = {
  formControlNames: [LEGAL_FORM_LEGAL_FORM_OF_OFFER_LEGAL],
  options: [
    {
      id: LegalSubscriptionType.PUBLIC,
      label: 'Public',
      effects: [],
    },
    {
      id: LegalSubscriptionType.PRIVATE,
      label: 'Private',
      effects: [],
    },
  ],
};
